module.exports = __webpack_public_path__ + "static/media/testimony3.e0ebff4d.png";